import { resume } from '../../data/resume';
import SectionHeading from '../layout/SectionHeading';

/**
 * Skills section: a grid of monospace tag pills with a hard offset shadow,
 * each chip's accent border cycling through a small muted retro palette.
 */
const ACCENTS = [
  { box: 'bg-accent-oxblood text-paper-base', border: 'border-accent-oxblood' },
  { box: 'bg-accent-dustyBlue text-paper-base', border: 'border-accent-dustyBlue' },
  { box: 'bg-accent-mustard text-ink', border: 'border-accent-mustard' },
  { box: 'bg-accent-olive text-paper-base', border: 'border-accent-olive' },
];

const Skills = () => (
  <section className="border-b-[3px] border-ink bg-paper-base px-8 py-10">
    <SectionHeading kana="技能" accent="text-accent-mustard">
      Skills
    </SectionHeading>

    <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
      {resume.skills.map((skill, i) => {
        const accent = ACCENTS[i % ACCENTS.length];
        return (
          <li
            key={skill}
            className={`group flex items-center gap-2 border-2 ${accent.border} bg-paper-warm px-3 py-2 shadow-sleeveSm transition-transform hover:-translate-x-0.5 hover:-translate-y-0.5`}
          >
            <span
              aria-hidden
              className={`flex h-5 w-5 shrink-0 items-center justify-center border-2 border-ink ${accent.box} font-mono text-[0.7rem] font-bold leading-none`}
            >
              ✓
            </span>
            <span className="font-mono text-sm font-bold uppercase tracking-retro text-ink">
              {skill}
            </span>
          </li>
        );
      })}
    </ul>
  </section>
);

export default Skills;
